import React, { useState } from 'react'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import DataTable from 'react-data-table-component'
import { CSVLink } from 'react-csv'
import moment from 'moment'
import { MdEdit } from 'react-icons/md'
import { TiDeleteOutline } from 'react-icons/ti'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { useEffect } from 'react'

export const Referral = () => {
  // table to display all referrral applications
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  const token = localStorage.getItem('token')
  const currentDate = new Date().toISOString().split('T')[0]

  const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [search, setSearch] = useState('')
  const [id, setId] = useState('')

  // get all fererral applications
  const getData = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'referral-statistics/fetchTableData', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setData(res.data.data)
        setFilteredData(res.data.data)
      })
      .catch((err) => {
        if (err.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  // delete application
  const deleteData = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'referral-statistics/deleteFormData',

        {
          id: id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        if (error.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  // filter data on onchage of search box
  const onChange = () => {
    const result = data.filter((item) => {
      return (
        item.designation.toLowerCase().match(search.toLowerCase()) ||
        item.candidate_name.toLowerCase().match(search.toLowerCase()) ||
        item.status_hr.toLowerCase().match(search.toLowerCase()) ||
        item.interview_round.toLowerCase().match(search.toLowerCase()) ||
        item.final_status.toLowerCase().match(search.toLowerCase()) ||
        item.final_status.match(search)
      )
    })

    setFilteredData(result)
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // columns to display data in table
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Name',

      cell: (row) => {
        return (
          <Tippy content={row.candidate_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.candidate_name}
            </p>
          </Tippy>
        )
      },
      width: '130px',
    },
    {
      name: 'Referred By',

      cell: (row) => {
        return (
          <Tippy content={row.candidate_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.referred_by}
            </p>
          </Tippy>
        )
      },
      width: '130px',
    },

    {
      name: 'Designation',
      cell: (row) => {
        return (
          <Tippy content={row.designation} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {' '}
              {row.designation}
            </p>
          </Tippy>
        )
      },

      width: '130px',
    },
    {
      name: 'Applied date',
      cell: (row) => {
        return (
          <Tippy content={row.applied_date} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {moment(row.applied_date).format('DD-MM-YYYY')}
            </p>
          </Tippy>
        )
      },

      width: '110px',
    },
    {
      name: 'HR Status',
      selector: (row) => row.status_hr,
      sortable: true,
    },
    {
      name: 'Interview Round',
      selector: (row) => row.interview_round,
      sortable: true,
      width: '120px',
    },
    {
      name: 'Final Status',
      cell: (row) => {
        return (
          <Tippy content={row.final_status} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.final_status}
            </p>
          </Tippy>
        )
      },
    },
    {
      name: 'Interviewer',
      cell: (row) => {
        return (
          <Tippy content={row.interviewer_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.interviewer_name}
            </p>
          </Tippy>
        )
      },
      width: '130px',
    },

    {
      name: 'Action',
      cell: (row) => {
        return (
          <>
            <Link to={'/referralProfile/' + row.uuid} className="link">
              <MdEdit className="editbtn" />
            </Link>

            <TiDeleteOutline
              className="deletebtn"
              data-bs-target="#deleteModal"
              onClick={() => {
                setId(row.uuid)
              }}
              data-bs-toggle="modal"
            />
          </>
        )
      },
    },
    {
      name: 'Assigned Owner',
      cell: (row) => {
        return (
          <Tippy content={row.owner_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.owner_name}
            </p>
          </Tippy>
        )
      },

      width: '130px',
    },
  ]

  // formate date and contact for csv file
  const formatdata = filteredData?.map((row) => ({
    ...row,
    applied_date: moment(row.applied_date).format('YYYY-MM-DD'),
    contact: `=""${row.contact}""`,
  }))

  //to get current pageindex of table
  const onPageChange = (pageIndex) => {
    global.pageNumber = pageIndex
  }

  return (
    <>
      <Sidebar />
      <div className="container p-4">
        <div className=" mt-3">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/home" className="link text-primary">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Referral Applications
              </li>
            </ol>
          </nav>
        </div>

        <div className="referral mt-4">
          <h5 className="text-primary"> Referral Applications</h5>
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover
            onChangePage={onPageChange}
            paginationDefaultPage={global.pageNumber ? global.pageNumber : 1}
            subHeader
            subHeaderComponent={
              <>
                <input
                  type="text"
                  placeholder="Search Here..."
                  className="w-25 form-control mx-3"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value)
                    localStorage.setItem('searchItemReferral', e.target.value)
                    onChange()
                  }}
                />

                <CSVLink
                  data={formatdata}
                  filename={'Referral Applications - ' + currentDate}
                >
                  <button className="btn btn-primary">Export</button>
                </CSVLink>
              </>
            }
          />
        </div>
        {/* modal for confirmation to delete aplication */}
        <div
          className="modal"
          tabIndex="-1"
          id="deleteModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Alert</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete the data ?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    deleteData()
                  }}
                  data-bs-dismiss="modal"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
